import { getMessageFromRtkError } from "~/lib/rtkErrorToMessage";
import {
  FulfillmentRequirements,
  OrderLine,
  OrderLineAcceptableSubstitutions
} from "~/redux/public/orders.openApi";
import { ErrorResponse } from "~/types/api";

const normalizeWeightThresholds = (
  fulfillmentRequirements?: FulfillmentRequirements
): FulfillmentRequirements | undefined => {
  const minimum =
    fulfillmentRequirements?.weightThresholds?.error?.minimum?.value;
  const maximum =
    fulfillmentRequirements?.weightThresholds?.error?.maximum?.value;

  if (minimum && maximum) {
    return {
      weightThresholds: {
        error: {
          minimum: { unit: "lb", value: minimum },
          maximum: { unit: "lb", value: maximum }
        }
      }
    };
  }

  return undefined;
};

const normalizeSubstitutionWeightThresholds = (
  substitution: OrderLineAcceptableSubstitutions
): OrderLineAcceptableSubstitutions => {
  const fulfillmentRequirements = normalizeWeightThresholds(
    substitution.fulfillmentRequirements
  );

  if (fulfillmentRequirements) {
    return { ...substitution, fulfillmentRequirements };
  }

  const { fulfillmentRequirements: _, ...rest } = substitution;
  return rest;
};

export const normalizeLineItemWeightThresholds = (
  lineItem: OrderLine
): OrderLine => {
  const fulfillmentRequirements = normalizeWeightThresholds(
    lineItem.fulfillmentRequirements
  );
  const acceptableSubstitutions = lineItem.acceptableSubstitutions?.map(
    normalizeSubstitutionWeightThresholds
  );

  if (fulfillmentRequirements) {
    return {
      ...lineItem,
      fulfillmentRequirements,
      acceptableSubstitutions
    };
  }

  const { fulfillmentRequirements: _, ...rest } = lineItem;
  return { ...rest, acceptableSubstitutions };
};

// custom client b and public endpoints have a non-standard error format
export const getErrorMessage = (error: unknown) => {
  const legacyError = error as {
    data?: ErrorResponse;
  };
  if (legacyError.data?.errorCode && legacyError.data?.message) {
    return `${legacyError.data.errorCode}: ${legacyError.data.message}`;
  }
  const publicApiError = error as {
    data?: { "error Info": string[] };
  };
  if (publicApiError.data?.["error Info"].length) {
    return publicApiError.data["error Info"].join(", ");
  }
  return getMessageFromRtkError(error);
};
